import { Box } from '@mui/material';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { AuthMethod } from 'types';
import { useRedirect } from 'services/hooks';
import { analytics, events } from 'services/analytics';
import { locations } from 'services/routes/locations';
import { LoginFormContainer } from './components/LoginForm';

interface LocationState {
  from?: Location;
}

const Login = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { from } = (location.state ?? {}) as LocationState;

  const navigate = useNavigate();

  const { getRedirectionPath } = useRedirect();

  /**
   * There was a bug that wrongly redirected to the password reset after logging in.
   * This seems to be a deeper problem with our funnels where funnels are badly applied
   * and it was decided with PO to only hotfix this issue here for this exact case.
   * @see https://justaddmusic.atlassian.net/browse/STR-2534
   */
  const loginRedirectionPath =
    getRedirectionPath() === locations.general.passwordReset.pathname
      ? locations.general.songList
      : getRedirectionPath();

  const onSuccess = (method: AuthMethod) => {
    analytics.track(events.login(method));

    const redirectUrl = searchParams.get('redirect');
    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    if (from) {
      navigate(from.pathname);
      return;
    }

    navigate(loginRedirectionPath);
  };

  return (
    <Box>
      <LoginFormContainer onSuccess={onSuccess} />
    </Box>
  );
};

export default Login;
